// Material
import { styled } from '@mui/material/styles'
import { Badge, IconButton } from '@mui/material'
// Common
import { CameraIcon } from '$common/icons/camera'

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  border: `4px solid ${theme.palette.white}`,
  color: theme.palette.white,
  padding: '4px',
  width: '44px',
  height: '44px',
  boxSizing: 'border-box',
  ':hover': {
    // TODO: REPLACE WITH THEME PALETTE
    backgroundColor: '#458DDE',
  },
}))

const StyledBadge = styled(Badge)`
  .MuiBadge-anchorOriginBottomRight {
    right: 7px;
    bottom: 7px;
  }
`

export function WithEditableAvatar({
  onSelectClick,
  children,
}: {
  onSelectClick: () => any
  children: JSX.Element
}) {
  return (
    <StyledBadge
      sx={{ margin: '0 auto' }}
      badgeContent={
        <StyledIconButton size="large" onClick={onSelectClick}>
          <CameraIcon sx={{ fontSize: '20px' }} />
        </StyledIconButton>
      }
      anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
    >
      {children}
    </StyledBadge>
  )
}
